<template>
  <div class="rx-app-header-container">
    <span class="arrow-icon">
      <svg viewBox="0 0 11 19" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M9.26477 1.10474L1.26477 9.10474L9.26477 17.1047" stroke="white" stroke-width="2"
          stroke-linecap="round" stroke-linejoin="round" />
      </svg>
    </span>
    <div class="title" :class="{ 'as-font': isFont }">{{ title }}</div>
  </div>
</template>

<script>
export default {
  name: 'HanderNav',
  props: {
    isFont: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: '融星贷·放心'
    }
  }
}
</script>

<style lang="less" scoped>
.rx-app-header-container {
  display: flex;
  align-items: center;
  padding-top: 10px;
  margin-bottom: 16px;

  .arrow-icon svg {
    width: 8px;
    height: 16px;
    aspect-ratio: 1/2;
  }

  .title {
    width: 100%;
    color: rgba(38, 72, 117, 0.78);
    text-align: center;

    font-size: 16px;
    font-style: normal;
    font-weight: 700;
    line-height: 21px;
  }

  .as-font {
    font-family: "AlimamaShuHeiTi";
  }
}
</style>
